/* ArtGalerie-TC: draws the signature line under main headings and reveals
   [data-ag-reveal] elements (cards, timeline, forms) as they scroll into view. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = !reduce && 'IntersectionObserver' in window;
  var lineIO = null;
  var revealIO = null;

  if (canObserve) {
    lineIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-drawn'); lineIO.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  }

  function decorate(root) {
    var heads = root.querySelectorAll('main h1, main h2, main .h1, main .h2');
    heads.forEach(function (h) {
      if (h.classList.contains('ag-line')) return;
      if (h.closest('.ag-no-line, [class*="card"], .shopify-policy__container, .rte, product-card')) return;
      if (!h.textContent.trim()) return;
      h.classList.add('ag-line');
      var align = window.getComputedStyle(h).textAlign;
      if (align === 'center') h.classList.add('ag-center');
      else if (align === 'right' || align === 'end') h.classList.add('ag-end');
      if (lineIO) { lineIO.observe(h); } else { h.classList.add('is-drawn'); }
    });

    root.querySelectorAll('[data-ag-reveal]:not(.is-in)').forEach(function (el) {
      if (revealIO) { revealIO.observe(el); } else { el.classList.add('is-in'); }
    });
  }

  decorate(document);
  document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });
})();
